var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricitySymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#455063;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "light-bulb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    className: "cls-1",
    d: "M329.16,387.47a9.72,9.72,0,0,0,9.71-9.72v-136H368a48.6,48.6,0,1,0-48.59-48.6v29.15H280.56V193.11a48.6,48.6,0,1,0-48.6,48.6h29.15V377.77a9.73,9.73,0,0,0,19.45,0V241.71h38.87V377.77a9.72,9.72,0,0,0,9.73,9.7Zm9.71-194.38A29.16,29.16,0,1,1,368,222.25H338.87Zm-77.76,29.16H232a29.16,29.16,0,1,1,29.15-29.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "cls-1",
    d: "M77.84,29.12,115,60.34a9.72,9.72,0,0,0,12.49-14.89h0L90.35,14.23a9.72,9.72,0,1,0-12.5,14.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "cls-1",
    d: "M84.12,113.9,38.47,97.24a9.75,9.75,0,0,0-6.67,18.33h0l45.65,16.66a9.75,9.75,0,1,0,6.67-18.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "cls-1",
    d: "M478.68,62.61a9.66,9.66,0,0,0,6.23-2.28l37.22-31.21a9.72,9.72,0,0,0-12.49-14.89L472.42,45.45a9.71,9.71,0,0,0,6.26,17.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-1",
    d: "M66.76,193.11H18.16a9.72,9.72,0,0,0,0,19.44h48.6a9.72,9.72,0,1,0,0-19.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-1",
    d: "M574,103.09a9.72,9.72,0,0,0-12.44-5.8L515.85,114a9.71,9.71,0,0,0,3.33,18.86,9.31,9.31,0,0,0,3.34-.6l45.66-16.66A9.7,9.7,0,0,0,574,103.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    className: "cls-1",
    d: "M300,8.45c-107.3.11-194.26,87.07-194.38,194.37A221,221,0,0,0,206.89,395.38a12.81,12.81,0,0,0,1.18.72,30.69,30.69,0,0,1,13.59,22.49,29.05,29.05,0,0,0-11.39,46.65,29.1,29.1,0,0,0,0,38.87,29.14,29.14,0,0,0,21.66,48.59,9.72,9.72,0,0,0,0-19.44,9.72,9.72,0,0,1,0-19.44h97.23a9.72,9.72,0,0,0,0-19.44H232a9.73,9.73,0,0,1,0-19.45h97.2a9.72,9.72,0,0,0,0-19.44H232a9.72,9.72,0,0,1,0-19.44h97.2a9.72,9.72,0,0,0,0-19.44H241a50.52,50.52,0,0,0-23.32-37.37c-64.06-45.92-92.63-100.35-92.63-176.42a174.93,174.93,0,0,1,349.86,0c0,76.07-28.59,130.5-92.68,176.43a52.3,52.3,0,0,0-23.94,47.08,9.72,9.72,0,0,0,9.71,9.72h0a9.72,9.72,0,1,1,0,19.44,9.72,9.72,0,1,0,0,19.44,9.73,9.73,0,1,1,0,19.45,9.72,9.72,0,1,0,0,19.44,9.73,9.73,0,0,1,9.72,9.71,9.51,9.51,0,0,1-9.31,9.71H270.84a9.73,9.73,0,0,0-9.71,9.72V562.4a29.18,29.18,0,0,0,29.14,29.15h19.44a29.18,29.18,0,0,0,29.16-29.15v-9.71H368a29.14,29.14,0,0,0,21.66-48.6,29.08,29.08,0,0,0,0-38.87,29.07,29.07,0,0,0-11.39-46.65,30.73,30.73,0,0,1,13.46-22.44,9.52,9.52,0,0,0,1.3-.78A221,221,0,0,0,494.31,202.79C494.17,95.52,407.26,8.6,300,8.45ZM319.44,562.4a9.73,9.73,0,0,1-9.71,9.71H290.27a9.73,9.73,0,0,1-9.71-9.71v-9.71h38.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "cls-1",
    d: "M581.84,193.09h-48.6a9.72,9.72,0,0,0,0,19.44h48.6a9.72,9.72,0,0,0,0-19.44Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricitySymbol);
export default __webpack_public_path__ + "static/media/electricity-symbol.faaa27ab1d2c9f0e2f9c58487c08356d.svg";
export { ForwardRef as ReactComponent };